export const ERROR_RECOVERY_TYPES = {
  unexpected: {
    icon: 'error',
    severity: 'critical',
    actions: { retry: true, back: true, dashboard: true },
    titleKey: 'errors.recovery.unexpected.title',
    descriptionKey: 'errors.recovery.unexpected.description',
    hintKey: 'errors.recovery.unexpected.hint',
  },
  server: {
    icon: 'cloud_off',
    severity: 'critical',
    actions: { retry: true, back: true, dashboard: true },
    titleKey: 'errors.recovery.server.title',
    descriptionKey: 'errors.recovery.server.description',
    hintKey: 'errors.recovery.server.hint',
  },
  forbidden: {
    icon: 'lock',
    severity: 'warning',
    actions: { retry: false, back: true, dashboard: true },
    titleKey: 'errors.recovery.forbidden.title',
    descriptionKey: 'errors.recovery.forbidden.description',
  },
  offline: {
    icon: 'wifi_off',
    severity: 'warning',
    actions: { retry: true, back: true, dashboard: true },
    titleKey: 'errors.recovery.offline.title',
    descriptionKey: 'errors.recovery.offline.description',
    hintKey: 'errors.recovery.offline.hint',
  },
  timeout: {
    icon: 'schedule',
    severity: 'warning',
    actions: { retry: true, back: true, dashboard: true },
    titleKey: 'errors.recovery.timeout.title',
    descriptionKey: 'errors.recovery.timeout.description',
    hintKey: 'errors.recovery.timeout.hint',
  },
  not_found: {
    icon: 'search_off',
    severity: 'info',
    actions: { retry: false, back: true, dashboard: true },
    titleKey: 'errors.recovery.not_found.title',
    descriptionKey: 'errors.recovery.not_found.description',
  },
};
